import NavbarComponent from '../Navbar';
import DataManagementForm from './DataManagement-comp';

const DataManagement = () => {
  return (
    <>
      <DataManagementForm />
    </>
  );
};

export default DataManagement;